// removed by extract-text-webpack-plugin
module.exports = {"container":"build_v16-container-2yAciirE84U","button":"build_v16-button-bpMp3eWLfiQ","button-without-text":"build_v16-button-without-text-fzwuDfl6aOQ","icon":"build_v16-icon-iudw1VvpMAw","icon--active":"build_v16-icon--active-77UG4yuqruO"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/favorite_button/index.css
// module id = 116
// module chunks = 2